<h3>Categoria chiave pubblica</h3>
<h6>Regolamento</h6>
<p>
	Questa gara comprende unicamente una fase di attacco.<br>
	Il 14 novembre ad ogni squadra sono fornite le medesime chiavi pubbliche di 
	crittosistemi asimmetrici:
</p>
<ul>
	<li> almeno 10 chiavi pubbliche per <a href="http://it.wikipedia.org/wiki/RSA">RSA</a> 
		di cui:
		<ul>
			<li>almeno 7 di queste di dimensione crescente da 100 a 500 bit (che si possono 
				rompere con algoritmi di fattorizzazione);</li>
			<li>almeno 3 di queste lunghe fino a 1000 bit (che però sono chiavi deboli);</li>
		</ul>
	</li>
	<li> almeno 3 chiavi pubbliche di un cifrario su <a href="http://en.wikipedia.org/wiki/
		Elliptic_curve_cryptography">curve ellittiche</a>;</li>
	<li> almeno 1 chiave pubblica di un cifrario su <a href="http://en.wikipedia.org/wiki/
		Hyperelliptic_curve_cryptography">curve iperellittiche</a>;</li>
	<li> almeno 1 chiave pubblica di <a href="http://en.wikipedia.org/wiki/
		Hidden_Field_Equations">HFE</a>;</li>
	<li> almeno 1 chiave pubblica su <a href="http://en.wikipedia.org/wiki/NTRUEncrypt">
		reticoli</a>;</li>
</ul>
<br>
<p>
	Ogni squadra deve cercare di trovare la chiave privata dei crittosistemi a partire da 
	quelle pubbliche usando tutti i mezzi, matematici e informatici (leciti!) a loro 
	disposizione.<br>
	Attenzione, le CryptoWars non sono un Hacking Contest, ma una gara di Crittografia.<br>
	Questa gara si conclude il 12 marzo 2011.
</p>
<h6>Punteggio</h6>
<p>
	Ogni qualvolta una chiave viene rotta, tale squadra guadagnerà dei punti (a seconda 
	della lunghezza della chiave e del crittosistema) e tale chiave viene tolta dalla lista 
	di quelle attaccabili. 
</p>
